import React, { useEffect } from 'react';
import Navbar from '../Home/LandingComponents/Navbar';
import Footer from '../Home/LandingComponents/Footer';

const LegalPage = ({ title, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-outfit">
      <Navbar />
      <main className="flex-grow li-pt-20">
        <section className="li-section">
          <div className="li-container" style={{ maxWidth: '48rem' }}>
            <h1 className="li-section-title" style={{ marginBottom: '3rem', textAlign: 'left' }}>{title}</h1>
            <div className="legal-content" style={{ color: '#4b5563', lineHeight: 1.8, fontSize: '1.125rem' }}>
              {children}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
